import Image from 'app/Components/Shared/Image/image';
import React, {memo, useState} from 'react';
import FAQItemBlockData from 'app/Models/Content/FAQItemBlockData';
import classNames from 'classnames';
import {Collapse} from 'reactstrap';
import reactStringReplace from 'react-string-replace';

type FAQItemBlockProps = {
  data: FAQItemBlockData;
  isBuisness: boolean;
  onOpen(): void;
};

const FAQItemBlock = ({isBuisness, onOpen, data: {answer, question}}: FAQItemBlockProps) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={classNames('FAQItemBlock', {buisness: isBuisness})}>
      <div className='FAQItemBlock__wrapper'>
        <div
          className='FAQItemBlock__question'
          onClick={() => {
            open || onOpen();
            setOpen(!open);
          }}>
          <div className='FAQItemBlock__question__text'>
            {reactStringReplace(question.value, '?', (m, index) => (
              <span className='highlight' key={index}>
                {m}
              </span>
            ))}{' '}
          </div>
          {isBuisness && (
            <Image className={classNames('FAQItemBlock__question__arrow', {open})} src={require('./images/arrow-left-business.svg')} />
          )}
         {!isBuisness && <Image className={classNames('FAQItemBlock__question__arrow', {open})} src={require('./images/arrow-larger.svg')} />}
        </div>
        <Collapse isOpen={open} className='FAQItemBlock__answer'>
        <div className='FAQItemBlock__answer__inner' dangerouslySetInnerHTML={{__html: answer.value}}></div>
        </Collapse>
      </div>
    </div>
  );
};

export default memo(FAQItemBlock);
